import { getCSSAnimation } from '@wix/motion'
import type { DomApplier } from '../cssFeatures.types'
import { getVariantSelectors } from '../../utils/variantsUtils'

export const motionTimeAnimationsDomApplier: DomApplier<'motionTimeAnimations'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ motionTimeAnimations: animations },
	cssContext
) => {
	if (animations) {
		return animations
			.flatMap(({ data: breakpointToEffect, variants }) => {
				return breakpointToEffect[breakpointId]
					? Object.entries(breakpointToEffect[breakpointId]).map(([variantKey, item]) => {
						const variantSelectors = getVariantSelectors(variantKey, variants, compId, cssContext)
						const selectors = variantSelectors.join(', ')
						let animations_: Array<{ animation?: string; composition?: string; custom?: Record<string, any> }> = []

						if (item) {
							animations_ = item.namedEffect ? getCSSAnimation(null, item) : [{}]
						}

						return {
							selectors,
							animations: animations_,
						}
					})
					: []
			})
			.reduce((styleRules, effectVariant) => {
				effectVariant.animations.forEach(({ animation = 'none', composition = 'replace', custom = {} }) => {
					const target = effectVariant.selectors

					if (styleRules[target]) {
						const {
							animation: existingAnimation,
							'animation-composition': existingComposition,
						} = styleRules[target] as { animation: string; 'animation-composition': string } & {
							[customKey: string]: string
						}

						if (existingAnimation) {
							styleRules[target].animation = `${existingAnimation}, ${animation}`
							styleRules[target]['animation-composition'] = `${existingComposition}, ${composition}`
						} else {
							styleRules[target].animation = animation
							styleRules[target]['animation-composition'] = composition
						}

						Object.assign(styleRules[target], custom)
					} else {
						styleRules[target] = {
							animation,
							'animation-composition': composition,
							...custom,
						}
					}
				})

				return styleRules
			}, {} as Record<string, Record<string, string>>)
	}

	return null
}
